import { render, staticRenderFns } from "./BasicSalaryDialog.vue?vue&type=template&id=3206d0bc&scoped=true"
import script from "./BasicSalaryDialog.vue?vue&type=script&lang=js"
export * from "./BasicSalaryDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3206d0bc",
  null
  
)

export default component.exports